export default ({ src, async = true, defer = false, onload }) => {
    const s = document.createElement('script');
    s.src = src;
    s.async = async;
    s.defer = defer;
    if (onload) s.onload = onload;
    document.head.appendChild(s);
    return s;
};
